import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IAdminWatchesQuantityField {
	setAdminWatchesQuantity: (value: null | number) => void;
}

const AdminWatchesQuantityField: React.FC<IAdminWatchesQuantityField> = ({ setAdminWatchesQuantity }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterAdminWatchesQuantity') }], [t]);

	return (
		<FormInput
			testId="AdminWatchesQuantityField"
			name="adminWatchesQuantity"
			label="adminWatchesQuantityLabel"
			placeholder="Enter number from 0 to 1"
			type="number"
			onChangeNumber={setAdminWatchesQuantity}
			validationRules={validationRules}
			min={0}
			max={1}
		/>
	);
};

export default React.memo(AdminWatchesQuantityField);
